import React,{useState,createContext} from 'react'


const AuthContext = createContext(null);

export default AuthContext